export class Product {
    id = -1;
    iconUrl?: string;
    name: ProductType = ProductType.PersonalTax;
    subscribable = false;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.iconUrl = data.icon;
        this.name = data.name ?? ProductType.PersonalTax;
        this.subscribable = data.subscribable ?? false;
        return this;
    }
}

export enum ProductType {
    PersonalTax = 'PERSONAL_TAX',
    Scenarios = 'SCENARIOS',
    Depreciations = 'DEPRECIATIONS',
    VatImport = 'VAT_IMPORT',
    DocImport = 'DOC_IMPORT',
    NonProfit = 'NON_PROFIT',
    KnowledgeCenter = 'KNOWLEDGE_CENTER',
    BudgetImport = 'BUDGET_IMPORT',
    AnnualReport = 'ANNUAL_REPORT',
    FinancialDashboard = 'FINANCIAL_DASHBOARD',
    CustomersSuppliersImport = 'CUSTOMERS_SUPPLIERS_IMPORT',
}
